import { render, staticRenderFns } from "./places-to-visit-in-goa.vue?vue&type=template&id=6f8720b4&scoped=true"
import script from "./places-to-visit-in-goa.vue?vue&type=script&lang=js"
export * from "./places-to-visit-in-goa.vue?vue&type=script&lang=js"
import style0 from "./places-to-visit-in-goa.vue?vue&type=style&index=0&id=6f8720b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8720b4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainCategoryCard: require('/workspace/components/MainCategoryCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
